import { useDispatch, useSelector } from 'react-redux'
import ConfirmModal from '../../../components/ConfirmModalV2'
import { setBackBarFinalizeModals } from '../../ActionCreators'
import { getOrderAmountInCents, getOrderPayments } from '../../../selectors/order'
import { useMemo, useState } from 'react'
import TipEntryModal from '../../../components/TipEntryModal'
import useBackBar from '../../../VNTabs/hooks/useBackBar'
import { centsToDollars } from '../../../utils/formatters'

export const VNBackBarEnterTipModal = () => {
  const dispatch = useDispatch()
  const { confirmTipHandler } = useBackBar()
  const [tipAmountInCents, setTipAmountInCents] = useState(0)
  const [isConfirm, setIsConfirm] = useState(false)
  const amountInCents = useSelector(getOrderAmountInCents)
  const orderPayments = useSelector(getOrderPayments)
  const hasPayment = useMemo(() => orderPayments.length > 0, [orderPayments])

  if (!hasPayment) {
    return null
  }

  if (isConfirm) {
    return (
      <ConfirmModal
        onButtonOneClick={() => {
          setIsConfirm(false)
        }}
        onButtonTwoClick={() => {
          dispatch(setBackBarFinalizeModals(false))
          confirmTipHandler(tipAmountInCents)
        }}
        headerText={'Confirm Tip & Close Tab'}
        subtext={`Tip: ${centsToDollars(tipAmountInCents)}`}
        extraSubtext={`Total: ${centsToDollars(amountInCents + tipAmountInCents)}`}
        buttonOneText={'GO BACK'}
        buttonTwoText={'CLOSE TAB'}
        opaque={true}
      />
    )
  }

  return (
    <TipEntryModal
      key="custom"
      title="Enter Tip"
      saveButtonText="FINALIZE"
      isKiosk={false}
      initialValue={tipAmountInCents}
      onClose={() => {
        dispatch(setBackBarFinalizeModals(false))
      }}
      onSubmit={(tipAmountInCents) => {
        setTipAmountInCents(tipAmountInCents)
        setIsConfirm(true)
      }}
      noCloseOnSubmit={true}
      opaque={true}
    />
  )
}
